<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="9" xl="9">
        <v-card>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="3" xl="3">
                <v-autocomplete
                  clearable
                  class="font-weight-light"
                  label="Buscar Orden"
                  type="text"
                  autocomplete="off"
                  @keyup.enter="searchOrder(idToSearch)"
                  :items="searchDataKeys"
                  hide-details
                  outlined
                  v-model="idToSearch"
                  dense
                  :loading="loadingSearch"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="3" xl="3">
                <v-select
                  :items="orderBy"
                  v-model="orderBySelected"
                  item-text="text"
                  item-value="id"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" class="d-flex pt-0">
                <v-checkbox
                  hide-details
                  class="ma-0 mr-3"
                  v-model="orderCheckbox"
                  label="Ordenes"
                ></v-checkbox>
                <v-checkbox
                  hide-details
                  class="ma-0 mr-3"
                  v-model="saleCheckbox"
                  label="Pedidos"
                ></v-checkbox>
                <v-checkbox
                  hide-details
                  class="ma-0"
                  v-model="serieCheckbox"
                  label="Serie de equipo"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" class="">
                <div class="d-flex justify-center mt-2" v-if="loadingData">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="50"
                  ></v-progress-circular>
                </div>
                <div v-if="searchActive">
                  <template v-if="historyData != null && historyData">
                    <v-container v-if="$vuetify.breakpoint.lgAndUp">
                      <v-row>
                        <v-col cols="2" class="caption py-0">
                          Serie
                        </v-col>
                        <v-col cols="2" class="caption py-0">
                          Equipo
                        </v-col>
                        <v-col cols="2" class="caption py-0">
                          Contacto
                        </v-col>
                        <v-col cols="2" class="caption py-0">
                          Orden
                        </v-col>
                        <v-col cols="4" class="caption py-0">
                          Fecha de incio
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-expansion-panels class="history" v-model="activePanel">
                      <v-expansion-panel
                        v-for="(order, i) in historyData"
                        :key="i"
                      >
                        <v-expansion-panel-header
                          class="pa-0"
                          :expand-icon="
                            $vuetify.breakpoint.lgAndUp ? 'expand_more' : ''
                          "
                        >
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="2"
                                xl="2"
                                class="text-truncate"
                                :class="{
                                  'py-0': $vuetify.breakpoint.mdAndDown
                                }"
                                >{{ order.orderData.machineSerie }}</v-col
                              >
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="2"
                                xl="2"
                                class="text-truncate"
                                :class="{
                                  'py-0': $vuetify.breakpoint.mdAndDown
                                }"
                                >{{ order.orderData.machineDescription }}</v-col
                              >
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="2"
                                xl="2"
                                class="text-truncate"
                                :class="{
                                  'py-0': $vuetify.breakpoint.mdAndDown
                                }"
                                >{{ order.damageData.userContact }}</v-col
                              >
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="2"
                                xl="2"
                                class="text-truncate"
                                :class="{
                                  'py-0': $vuetify.breakpoint.mdAndDown
                                }"
                                >{{ order.damageData.saleOrderID }}</v-col
                              >
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="4"
                                xl="4"
                                class="text-truncate"
                                :class="{
                                  'py-0': $vuetify.breakpoint.mdAndDown
                                }"
                                >{{ order.damageData.date.toDate() }}</v-col
                              >
                            </v-row>
                          </v-container>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="6"
                              xl="6"
                              :class="{
                                'py-0': $vuetify.breakpoint.mdAndDown
                              }"
                            >
                              <v-row>
                                <v-col cols="3">
                                  <div
                                    class="body-2 text--secondary mb-1 text-truncate"
                                  >
                                    Contacto
                                  </div>
                                  <div
                                    class="body-2 text--secondary mb-1 text-truncate"
                                  >
                                    Telefono
                                  </div>
                                </v-col>
                                <v-col cols="9">
                                  <div
                                    class="primary--text body-2 mb-1 text-truncate"
                                  >
                                    {{ order.damageData.userContact }}
                                  </div>
                                  <div
                                    class="primary--text body-2 mb-1 text-truncate"
                                  >
                                    {{ order.damageData.userPhone }}
                                  </div>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="6"
                              xl="6"
                              :class="{
                                'py-0': $vuetify.breakpoint.mdAndDown
                              }"
                            >
                              <v-row>
                                <v-col cols="4">
                                  <div
                                    class="body-2 text--secondary mb-1 text-truncate"
                                  >
                                    Orden de remisión
                                  </div>
                                  <div
                                    class="body-2 text--secondary mb-1 text-truncate"
                                  >
                                    Serie de equipo
                                  </div>
                                  <div
                                    class="body-2 text--secondary mb-1 text-truncate"
                                  >
                                    Modelo del equipo
                                  </div>
                                  <div
                                    class="body-2 text--secondary mb-1 text-truncate"
                                  >
                                    Descripción del equipo
                                  </div>
                                </v-col>
                                <v-col cols="8">
                                  <div
                                    class="primary--text body-2 mb-1 text-truncate"
                                  >
                                    {{ order.damageData.saleOrderID }}
                                  </div>
                                  <div
                                    class="primary--text body-2 mb-1 text-truncate"
                                  >
                                    {{ order.orderData.machineSerie }}
                                  </div>
                                  <div
                                    class="primary--text body-2 mb-1 text-truncate"
                                  >
                                    {{
                                      order.orderData.machineModel
                                        ? order.orderData.machineModel
                                        : "N/A"
                                    }}
                                  </div>
                                  <div
                                    class="primary--text body-2 mb-1 text-truncate"
                                  >
                                    {{ order.orderData.machineDescription }}
                                  </div>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12" class="pt-0">
                              <v-row align="center">
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  lg="2"
                                  xl="2"
                                  class="pt-0"
                                >
                                  <p class="ma-0 title mr-2">CHECKLIST</p>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  lg="4"
                                  xl="4"
                                  class="pt-0"
                                >
                                  <v-select
                                    height="30px"
                                    :items="orderBy"
                                    v-model="orderBySelectedChecklist"
                                    item-text="text"
                                    @change="orderChecklistByDate(i)"
                                    item-value="id"
                                    outlined
                                    hide-details
                                  ></v-select>
                                </v-col>
                              </v-row>
                              <div
                                v-for="(checklist,
                                indexChecklist) in order.checklist"
                                :key="indexChecklist"
                              >
                                <v-card
                                  link
                                  v-if="$vuetify.breakpoint.mdAndDown"
                                  @click="
                                    createChecklist(
                                      order,
                                      indexChecklist,
                                      checklist.completedChecklist
                                        ? 'consult'
                                        : 'save'
                                    )
                                  "
                                  class="pa-1 mb-1"
                                  outlined
                                >
                                  <div
                                    cols="12"
                                    class="py-0 body-2 text--secondary"
                                  >
                                    {{
                                      checklist.completed
                                        ? checklist.completed
                                        : "N/A"
                                    }}
                                  </div>
                                  <div
                                    cols="12"
                                    class="py-0 body-2 text--secondary"
                                  >
                                    <span class="indigo--text mr-1">{{
                                      checklist.name
                                    }}</span>
                                    <span class="indigo--text"
                                      >({{ checklist.status }})</span
                                    >
                                  </div>
                                  <div cols="12" class="py-0 ">
                                    <div v-if="checklist.completedChecklist">
                                      <span
                                        v-if="checklist.incidence"
                                        class="accent--text"
                                        >*Incidencia</span
                                      >
                                      <span v-else class="text--secondary"
                                        >Sin incidencias</span
                                      >
                                    </div>
                                    <span class="text--secondary" v-else
                                      >Por realizar</span
                                    >
                                  </div>
                                </v-card>
                                <template v-else>
                                  <v-card
                                    link
                                    @click="
                                      createChecklist(
                                        order,
                                        indexChecklist,
                                        checklist.completedChecklist
                                          ? 'consult'
                                          : 'save'
                                      )
                                    "
                                    class="d-flex align-center pa-1 mb-1"
                                    outlined
                                  >
                                    <div
                                      class="body-2 text--secondary mr-4 min-date-checklist"
                                    >
                                      {{
                                        checklist.completed
                                          ? checklist.completed
                                          : "N/A"
                                      }}
                                    </div>
                                    <div class="min-date-checklist">
                                      <span class="indigo--text mr-1">{{
                                        checklist.name
                                      }}</span>
                                      <span class="indigo--text"
                                        >({{ checklist.status }})</span
                                      >
                                    </div>
                                    <div v-if="checklist.completedChecklist">
                                      <span
                                        v-if="checklist.incidence"
                                        class="accent--text"
                                        >*Incidencia</span
                                      >
                                      <span v-else class="text--secondary"
                                        >Sin incidencias</span
                                      >
                                    </div>
                                    <span class="text--secondary" v-else
                                      >Por realizar</span
                                    >
                                  </v-card>
                                </template>
                              </div>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </template>
                  <div v-else class="subtitle-1 text-center">
                    <span v-if="!loadingData">
                      No se encontraron datos en la busqueda</span
                    >
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
        <v-card>
          <v-container>
            <p class="title">CHECKLIST</p>
            <div class="d-flex justify-center mt-2" v-if="loadingData">
              <v-progress-circular
                indeterminate
                color="primary"
                size="50"
              ></v-progress-circular>
            </div>
            <div v-if="searchActive">
              <template v-if="historyData != null && historyData">
                <div v-for="(order, i) in historyData" :key="i + 'checklist'">
                  <v-card
                    v-for="(checklist, indexChecklist) in order.checklist"
                    :key="indexChecklist"
                    :class="order.orderData.docID"
                    class="mb-1 row"
                    elevation="0"
                    link
                    @click="
                      createChecklist(
                        order,
                        indexChecklist,
                        checklist.completedChecklist ? 'consult' : 'save'
                      )
                    "
                  >
                    <v-col
                      class="caption text--secondary text-truncate pr-0"
                      cols="3"
                    >
                      {{ checklist.completed ? checklist.completed : "N/A" }}
                    </v-col>
                    <v-col class="caption" cols="5">
                      <span class="indigo--text mr-1">{{
                        checklist.name
                      }}</span>
                      <span class="indigo--text"
                        >({{ checklist.onlyLetter }})</span
                      >
                    </v-col>
                    <v-col
                      v-if="checklist.completedChecklist"
                      cols="4"
                      class="caption"
                    >
                      <span v-if="checklist.incidence" class="accent--text"
                        >*Incidencia</span
                      >
                      <span v-else class="text--secondary"
                        >Sin incidencias</span
                      >
                    </v-col>
                    <v-col class="text--secondary caption" v-else cols="4"
                      >Por realizar</v-col
                    >
                  </v-card>
                </div>
              </template>
              <div v-else class="subtitle-1 text-center">
                <span v-if="!loadingData">
                  No se encontraron datos en la busqueda</span
                >
              </div>
            </div>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      orderCheckbox: true,
      saleCheckbox: false,
      serieCheckbox: false,
      idToSearch: null,
      loadingData: false,
      historyData: null,
      searchActive: false,
      activePanel: null,

      loadingSearch: true,
      orderBy: [
        { text: "Fecha ascendente", id: "ascDate" },
        { text: "Fecha descendente", id: "dscDate" }
      ],
      orderBySelected: { text: "Fecha ascendente", id: "ascDate" },
      orderBySelectedChecklist: { text: "Fecha ascendente", id: "ascDate" }
    };
  },
  methods: {
    ...mapActions("dashboard", ["getDataSearchOrders", "getDataSearchSeries"]),
    ...mapActions("detail", ["getHistoryOrders", "getHistorySerie"]),
    async searchOrder(orderNumber) {
      this.searchActive = true;
      this.loadingData = true;
      this.historyData = null;
      if (this.serieCheckbox) {
        const data = await this.getHistorySerie(orderNumber);
        this.loadingData = false;
        this.historyData = data.length != 0 ? this.sortByData(data) : null;
      } else {
        orderNumber = orderNumber.replace(/_/g, "/");
        const noSpacesOrderNumber = orderNumber.split(" ").join("");
        const data = await this.getHistoryOrders({
          orderNumber: noSpacesOrderNumber,
          orderType: this.orderCheckbox ? "id" : "saleOrderID"
        });
        this.loadingData = false;
        this.historyData = data.length != 0 ? this.sortByData(data) : null;
      }
    },
    async getDataSearch() {
      this.loadingSearch = true;
      if (this.saleCheckbox) await this.getDataSearchOrders("damageSales");
      if (this.orderCheckbox) await this.getDataSearchOrders("damageOrders");
      if (this.serieCheckbox) await this.getDataSearchSeries();
      this.loadingSearch = false;
    },
    activeOrder(data, remove) {
      const orderClass = document.getElementsByClassName(data.orderData.docID);
      for (const order of orderClass) {
        order.style.backgroundColor = remove ? "unset" : "#dbdbdb";
      }
    },
    sortByData(historyData) {
      let newValues = [];
      if (this.orderBySelected === "ascDate") {
        if (historyData) {
          newValues = historyData.sort((a, b) =>
            a.damageData.date > b.damageData.date
              ? 1
              : b.damageData.date > a.damageData.date
              ? -1
              : 0
          );
        }
      } else {
        if (historyData) {
          newValues = historyData.sort((a, b) =>
            a.damageData.date < b.damageData.date
              ? 1
              : b.damageData.date < a.damageData.date
              ? -1
              : 0
          );
        }
      }
      return newValues;
    },
    orderChecklistByDate(element) {
      this.sortByDataChecklist(this.historyData[element].checklist);
    },
    sortByDataChecklist(checklistData) {
      if (this.orderBySelectedChecklist === "dscDate") {
        if (checklistData) {
          checklistData.sort((a, b) =>
            a.completed > b.completed ? 1 : b.completed > a.completed ? -1 : 0
          );
        }
      } else {
        if (checklistData) {
          checklistData.sort((a, b) =>
            a.completed < b.completed ? 1 : b.completed < a.completed ? -1 : 0
          );
        }
      }
    },
    createChecklist(orderData, indexChecklist, typeAction) {
      const url = this.$router.resolve({
        name: "checklist",
        params: {
          id: orderData.damageData.docID,
          productID: orderData.orderData.docID,
          event: orderData.checklist[indexChecklist].event,
          type: orderData.checklist[indexChecklist].type
        },
        query: {
          order: orderData.damageData.id,
          saleOrderID: orderData.damageData.saleOrderID,
          machineSerie: orderData.orderData.machineSerie,
          event: orderData.checklist[indexChecklist].name,
          inputOuput: orderData.checklist[indexChecklist].status,
          statusID: orderData.orderData.status,
          typeAction,
          backUrlSearch: this.$router.currentRoute.fullPath
        }
      });
      window.open(url.href, "_blank");
    }
  },
  computed: {
    ...mapState("dashboard", ["searchDataKeys"])
  },
  mounted() {
    this.getDataSearch();
    this.loadingSearch = false;
  },
  watch: {
    orderCheckbox(newValue) {
      if (newValue) {
        this.saleCheckbox = false;
        this.serieCheckbox = false;
        this.getDataSearch();
      }
    },
    saleCheckbox(newValue) {
      if (newValue) {
        this.orderCheckbox = false;
        this.serieCheckbox = false;
        this.getDataSearch();
      }
    },
    serieCheckbox(newValue) {
      if (newValue) {
        this.saleCheckbox = false;
        this.orderCheckbox = false;
        this.getDataSearch();
      }
    },
    activePanel(newValue, oldValue) {
      if (newValue != null && newValue != undefined)
        this.activeOrder(this.historyData[newValue], false);
      if (oldValue != null && oldValue != undefined)
        this.activeOrder(this.historyData[oldValue], true);
    },
    orderBySelected(newValue) {
      if (newValue) {
        if (this.historyData) {
          const tempData = [...this.historyData];
          this.historyData = this.sortByData(tempData);
        }
      }
    }
  }
};
</script>

<style>
.history > .v-expansion-panel::before {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.min-date-checklist {
  min-width: 147px;
}
.dense-select-date {
  height: 100px;
}
</style>
